export default "__VITE_ASSET__YQL4cbqN__"